import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import {
  DEFAULT_TIMEZONE,
  TIMEZONE_OPTIONS,
  setCurrentTimezone,
} from "../components/Copper/copperConfig";

const STORAGE_KEY = "app.timezone";

const TimezoneContext = createContext({
  timezone: DEFAULT_TIMEZONE,
  setTimezone: () => {},
  options: TIMEZONE_OPTIONS,
});

const readInitialTimezone = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && TIMEZONE_OPTIONS.some((o) => o.value === stored)) return stored;
  } catch {
    // localStorage may be unavailable (SSR / privacy mode); fall through.
  }
  return DEFAULT_TIMEZONE;
};

export const TimezoneProvider = ({ children }) => {
  const [timezone, setTimezoneState] = useState(readInitialTimezone);

  // Keep the formatter module in sync so plain render functions that call
  // fmtDate (outside of React) see the latest tz.
  useEffect(() => {
    setCurrentTimezone(timezone);
    try {
      window.localStorage.setItem(STORAGE_KEY, timezone);
    } catch {
      // ignore
    }
  }, [timezone]);

  const setTimezone = useCallback((tz) => {
    setTimezoneState(tz || DEFAULT_TIMEZONE);
  }, []);

  const value = useMemo(
    () => ({ timezone, setTimezone, options: TIMEZONE_OPTIONS }),
    [timezone, setTimezone]
  );

  return <TimezoneContext.Provider value={value}>{children}</TimezoneContext.Provider>;
};

export const useTimezone = () => useContext(TimezoneContext);
